<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Számlák</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/sales/invoices/add')"
        icon="el-icon-plus"
        v-can="'invoice.create'"
      >
        Új számla
      </el-button>
      <el-button
        style="margin-top: -5px; float: right; margin-right: 10px"
        size="small"
        @click="showBalanceDialog = true"
        v-can="'invoice.view'"
      >
        Egyenleg
      </el-button>
      <el-button
        style="margin-top: -5px; float: right;"
        size="small"
        @click="showBillableDialog = true"
        v-can="'invoice.create'"
      >
        Számlázandó szállítólevelek
      </el-button>
    </div>
    <div
      v-loading="loading"
      style="min-height: 81px;"
    >
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="invoice/fetchAll"
      />
    </div>
    <invoice-list/>
    <template v-if="$route.meta.showAddInvoiceDialog">
      <invoice-dialog
        type="add"
        :partner-id="partnerId"
        :sale-ids="saleIds"
        :representative-sale-ids="representativeSaleIds"
        @close="onAddInvoiceDialogClose"
      />
    </template>
    <template v-if="$route.meta.showUpdateInvoiceDialog">
      <invoice-dialog
        :invoice-id="parseInt($route.params.id)"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showInvoiceViewDialog">
      <invoice-dialog
        :invoice-id="parseInt($route.params.id)"
        type="view"
      />
    </template>
    <template v-if="$route.meta.showInvoicePaymentDialog">
      <payment-dialog
        :invoice-id="parseInt($route.params.id)"
      />
    </template>
    <el-dialog
      title="Számlázandó szállítólevelek"
      :visible="showBillableDialog"
      @close="onBillableDialogClose"
    >
      <billable-partner-list
        v-if="showBillableDialog"
        ref="billablePartnerList"
        @createInvoice="onCreateInvoice"
      />
    </el-dialog>
    <el-dialog
      title="Egyenleg"
      fullscreen
      :visible="showBalanceDialog"
      :close-on-click-modal="false"
      @close="onBalanceDialogClose"
    >
      <div slot="title">
        <span>Egyenleg</span>
        <el-button
          size="mini"
          style="margin-left: 5px;"
          @click="reloadBalance"
        >
          Frissítés
        </el-button>
      </div>
      <BalanceList ref="balanceList" />
    </el-dialog>
  </el-card>
</template>

<script>
import invoiceList from '../../components/sales/invoices/List';
import BalanceSum from '../../components/sales/invoices/balance/Sum';
import BalanceList from '../../components/sales/invoices/balance/List';
import invoiceDialog from '../../components/sales/invoices/Dialog';
import TableFilter from '../../components/TableFilter';
import BillablePartnerList from '../../components/dashboard/partnersWithBillable/PartnerList';
import PaymentDialog from '../../components/sales/invoices/PaymentDialog';

export default {
  components: {
    PaymentDialog,
    invoiceList,
    invoiceDialog,
    TableFilter,
    BillablePartnerList,
    BalanceSum,
    BalanceList,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
      showBillableDialog: false,
      showBalanceDialog: false,
      partnerId: 0,
      saleIds: [],
      representativeSaleIds: [],
    };
  },

  computed: {
    invoiceBooks() {
      return this.$store.getters['invoiceBook/invoiceBooks'];
    },
  },

  async mounted() {
    this.loading = true;
    if (!this.invoiceBooks || !this.invoiceBooks.length) {
      await this.$store.dispatch('invoiceBook/fetchAll', '');
    }
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    reloadBalance() {
      this.$refs.balanceList.load()
    },
    async setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'invoice_number',
          label: 'Szamlaszám',
          defaultSearch: true,
        },
        {
          type: 'select',
          name: 'invoice_book',
          options: this.invoiceBooks,
          label: 'Számlatömb',
          labelCallback: b => b.name,
          valueKey: 'id',
        },
        {
          type: 'dateRange',
          name: 'issue_date',
          label: 'Kiállítás dátuma',
        },
        {
          type: 'dateRange',
          name: 'delivery_date',
          label: 'Teljesítés dátuma',
        },
        {
          type: 'dateRange',
          name: 'paid_date',
          label: 'Kiegyenlítes dátuma',
        },
        {
          type: 'dateRange',
          name: 'payment_date',
          label: 'Fizetési határidő',
        },
        /* {
          type: 'date',
          label: 'Korosított kintlévőségek - Kezdő dátum',
          name: 'aging_start_date'
        },
        {
          type: 'date',
          label: 'Korosított kintlévőségek - Vég dátum',
          name: 'aging_end_date'
        }, */
        {
          type: 'date',
          label: 'Korosított kintlévőségek - Viszonyítási dátum',
          name: 'aging_comparison_date'
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Lezárva',
              status: 'done'
            },
            {
              label: 'Sztornózva',
              status: 'cancelled'
            },
            {
              label: 'Módosítva',
              status: 'modified'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Kiegyenlítve',
              payment_status: 'fully',
            },
            {
              label: 'Részben kiegyenlítve',
              payment_status: 'partly'
            },
            {
              label: 'Nincs kiegyenlítve',
              payment_status: 'none'
            },
            {
              label: 'Nincs kiegyenlítve vagy részben kiegyenlítve',
              payment_status: 'none_partly'
            },
          ],
          name: 'payment_status',
          label: 'Kiegyenlítés állapota',
          labelCallback: status => status.label,
          valueKey: 'payment_status',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Igen',
              is_expired: 1,
            },
            {
              label: 'Nem',
              is_expired: 0
            },
          ],
          name: 'is_expired',
          label: 'Lejárt számla',
          labelCallback: status => status.label,
          valueKey: 'is_expired',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Normál',
              value: 'CREATE'
            },
            {
              label: 'Sztornó',
              value: 'STORNO'
            },
            {
              label: 'Módosító okirat',
              value: 'MODIFY'
            },
          ],
          name: 'category',
          label: 'Típus',
          labelCallback: status => status.label,
          valueKey: 'value',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Készpénz',
              value: 'CASH'
            },
            {
              label: 'Átutalás',
              value: 'TRANSFER'
            },
          ],
          name: 'payment_method',
          label: 'Fizetés módja',
          labelCallback: status => status.label,
          valueKey: 'value',
        },
        {
          type: 'remote',
          name: 'customer_id',
          label: 'Vevő',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/activeSearch',
        },
        {
          type: 'text',
          name: 'customer_delivery_address',
          label: 'Vevő szállítási címe',
        },
          {
            type: 'select',
            options: [
              {
                nav_status: 'not-send',
                label: 'Küldésre vár',
              },
              {
                label: 'Nem kell küldeni',
                nav_status: 'no-need',
              },
              {
                label: 'Feldolgozás alatt',
                nav_status: 'processing',
              },
              {
                label: 'Elutasítva',
                nav_status: 'sent-error',
              },
              {
                label: 'Elutasítva',
                nav_status: 'aborted',
              },
              {
                label: 'Elküldve',
                nav_status: 'sent-success',
              },
              {
                label: 'Elküldve hibával',
                nav_status: 'sent-warning',
              },
            ],
            name: 'nav_status',
            label: 'NAV státusz',
            labelCallback: nav_status => nav_status.label,
            valueKey: 'nav_status',
          },
          {
            type: 'text',
            name: 'id',
            label: 'ID'
          },
      ];
    },
    onAddInvoiceDialogClose() {
      this.saleIds = [];
      this.partnerId = 0;
    },
    onBillableDialogClose() {
      this.showBillableDialog = false;
    },
    onBalanceDialogClose() {
      this.showBalanceDialog = false;
    },
    onCreateInvoice(data) {
      this.partnerId = data.customerId;
      this.saleIds = data.selectedSaleIds;
      this.representativeSaleIds = data.selectedRepresentativeSaleIds;
      this.$router.replace('/sales/invoices/add');
    },
  },
};
</script>
